export type Config = {
    /**
     @deprecate "dd is not used any more"
     **/
    dd_env?: string;
    /**
     @deprecate "dd is not used any more"
     **/
    dd_service?: string;
    /**
     @deprecate "dd is not used any more"
     **/
    dd_version?: string;
    /**
     @deprecate "dd is not used any more"
     **/
    dd_application_id?: string;
    /**
     @deprecate "dd is not used any more"
     **/
    dd_client_token?: string;

    faro_endpoint?: string
    faro_key?: string;

    tracer_name?: string;
    environment?: string;
    version?: string;
}

export const loadConfig = async (): Promise<Config> => {
    return fetch("env.json").then(r => r.json())
}